import { render, staticRenderFns } from "./LS04.vue?vue&type=template&id=6706ed6f&scoped=true"
import script from "./LS04.vue?vue&type=script&lang=js"
export * from "./LS04.vue?vue&type=script&lang=js"
import style0 from "./LS04.vue?vue&type=style&index=0&id=6706ed6f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6706ed6f",
  null
  
)

export default component.exports